// libs
import React, { ReactElement } from 'react';
// components
import ShowPageLayout from 'framework/ui/layout/ShowPageLayout/ShowPageLayout';
import SensitiveDataPlug from './SensitiveDataPlug';
import ToggleSensitiveDataButton from './buttons/ToggleSensitiveDataButton';
import type { ToggleSensitiveDataButtonProps } from './buttons/ToggleSensitiveDataButton';
// services
import useSensitiveDataService from './sensitiveDataService';
interface SensitiveShowPageLayoutProps {
  buttons?: ReactElement[];
  children?: ReactElement | ReactElement[];
  timerId?: string;
  toggleSensitiveDataButtonProps?: Partial<ToggleSensitiveDataButtonProps>;
  [key: string]: any;
}

const SensitiveShowPageLayout: React.FC<SensitiveShowPageLayoutProps> = ({
  buttons = [],
  children,
  timerId,
  toggleSensitiveDataButtonProps,
  ...other
}) => {
  const { isTimerActive, isShown, toggleSensitiveData, isSensitiveDataLoading } = useSensitiveDataService({ timerId });

  const getButtons = () => {
    const buttonsArray = [...buttons];
    const toggleButton = (
      <ToggleSensitiveDataButton
        key="toggle-sensitive-data"
        isShown={isShown}
        onClick={() => toggleSensitiveData([])}
        disabled={isSensitiveDataLoading}
        isTimerActive={isTimerActive}
        {...toggleSensitiveDataButtonProps}
      />
    );

    buttonsArray.unshift(toggleButton);

    return buttonsArray;
  };

  return (
    <ShowPageLayout buttons={getButtons()} {...other}>
      {(isShown ? children : <SensitiveDataPlug />) as ReactElement}
    </ShowPageLayout>
  );
};

export default SensitiveShowPageLayout;
